export default Object.freeze({
  TITLE: '회원등급/그룹 선택',
  TARGET_RANGE: '대상 범위',
  MEMBER_GRADE: '회원등급',
  MEMBER_GROUP: '회원그룹',
  DESCRIPTION_AND: '대상범위 ‘회원등급 and 회원그룹’에서 대상회원은 선택한 대상 회원 등급이면서 대상 회원 그룹인 회원입니다.',
  DESCRIPTION_AND_EXAMPLE: '(ex. 대상회원등급을 ‘A 등급’, 대상회원그룹을 ‘가 그룹’으로 설정 시, 회원 등급이 ‘A등급‘ 이고, 회원그룹이 ‘가 그룹‘인 회원을 대상으로 함)',
  DESCRIPTION_OR: '대상범위 ‘회원등급 or 회원그룹’에서 대상회원은 선택한 대상 회원 등급이거나 대상 회원 그룹인 회원입니다.',
  DESCRIPTION_OR_EXAMPLE: '(ex. 대상회원등급을 ‘A 등급’, 대상회원그룹을 ‘가 그룹’으로 설정 시, 회원 등급 ‘A등급‘ 인 회원 또는 회원그룹이 ‘가 그룹‘인 회원을 대상으로 함)',
  GRADE_TITLE: '대상 회원 등급',
  GROUP_TITLE: '대상 회원 그룹',
  SAVE_BTN: '저장',
  CANCEL_BTN: '닫기',
  ALERT_TEXT: '회원 등급/그룹 중 하나 이상 선택해주세요.',
  RECEIPIENT_TITLE: 'SMS/e-mail을 발송할 회원을 선택합니다.',
  MEMBER_ALL: '전체회원',
  NO_SELECT: '선택 안 함',
  SELECT: '전체',
  UNIT: '명'
});
